import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { createActionSettingsSchema, getFieldInfoByName } from './Util';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import BrowserStorageOptions from '../BrowserStorageOptions';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomLoader from '../../../common/CustomLoader';

export const BulkCollectionEdit = ({
  hideModal,
  actions,
  eventAction,
  actionData,
  selectedEvent,
  showLoaderForAction,
  projectId,
  events,
  version,
}) => {
  const [showBSLOption, setShowBSLOption] = useState(false);

  const collectionRequestOptions = () => {
    let options = [
      { value: 'Secured', label: 'Secured (LoggedIn User)' },
      { value: 'Open', label: 'Open (Non-LoggedIn User)' },
    ];
    return options;
  };

  const validateFormDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateFormDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  const validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);
        resetForm();
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, isValidating }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Choose Request Type"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Choose Request Type.'}
                >
                  <CustomSelect
                    name={'collectionRequest'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionRequestOptions()}
                    value={values['collectionRequest']}
                    placeholder={'Select Request Type (Optional)'}
                  />
                  <ErrorMessage
                    name="collectionRequest"
                    component="p"
                    className="text-error ml-5"
                  />
                </FormFieldWithLabel>
                <small style={{ paddingLeft: '8%' }}>
                  Select the type of users to whom you allow adding new data to collection .
                </small>
              </div>

              <div className="form-group">
                <div className="col-12">
                  <div className="form-check pl-3">
                    <label className="form-check-label">
                      <Field
                        type="checkbox"
                        name={'skipEmptyValues'}
                        className="form-check-input"
                        title={'skipEmptyValues'}
                      />
                      {'Skip Empty Values (Only updates non-empty fields)'}
                      <span className="form-check-sign">
                        <span className="check"></span>
                      </span>
                    </label>
                  </div>
                  <ErrorMessage name={'skipEmptyValues'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </div>
              </div>

              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    type="text"
                    name="successMessage"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Success Message"
                  />
                </FormFieldWithLabel>
                <ErrorMessage name="successMessage" component="p" className="text-error ml-5" />
              </div>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    type="text"
                    name="errorMessage"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Error Message"
                  />
                </FormFieldWithLabel>
                <ErrorMessage name="errorMessage" component="p" className="text-error ml-5" />
              </div>
              <div className="form-group">
                <button
                  onClick={() => setShowBSLOption(!showBSLOption)}
                  className="btn btn-icon-only btn-outline-info ml-5 p-1"
                  title="Show Browser Storage Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                </button>
              </div>

              {showBSLOption && (
                <BrowserStorageOptions
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validateFormDataSessionKey={validateFormDataSessionKey}
                  validateResponseDataSessionKey={validateResponseDataSessionKey}
                />
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i> Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className={`btn btn-sm btn-theme-submit`}>
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
